import { useEffect, useState } from 'react';

import type { DeliveryFormat } from '../../data-builder.store';
import { DeliveryFormatRadios } from './DeliveryFormatRadios';

type DownloadConfigFormProps = {
  initialValue: DeliveryFormat | null;
  onSave: (format: DeliveryFormat) => void;
};

export const DownloadConfigForm = ({
  initialValue,
  onSave,
}: DownloadConfigFormProps) => {
  const [selectedFormat, setSelectedFormat] = useState<DeliveryFormat>(
    initialValue ?? 'excel'
  );

  useEffect(() => {
    setSelectedFormat(initialValue ?? 'excel');
  }, [initialValue]);

  return (
    <DeliveryFormatRadios
      name="data-builder-download-format"
      value={selectedFormat}
      onChange={(format) => {
        setSelectedFormat(format);
        onSave(format);
      }}
    />
  );
};
